import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/CartaCategoria.module.scss'
import { DatoContacto } from './DatoContacto';
export const CartaCategoria = ({ imagen, nombre, url, id, active}) => {

    return (
        <a href={url} className='text-decoration-none text-black'>
            <div id={id} className={styles.categoria + ' mx-5 ' + (active? styles.active:'')}>
                <div className={styles.fondoCategoria}>
                    <img src={imagen} className={styles.imagenCategoria} />
                </div>
                <p className={styles.nombre}>{nombre.toUpperCase()}</p>
            </div>
        </a>
    )

}
